export default "__VITE_ASSET__DZq9yY9A__"